<template>
  <div class="create-box">
    <div class="title">比赛信息</div>
    <div class="form">
      <my-input v-model="game.stageName" table="当前阶段" placeholder="请选择阶段" disabled @inputClick="stageType()" />
      <!--      <my-input v-model="game.ruleType" table="赛事类型" placeholder="请选择赛事类型" disabled @inputClick="selectType()" />-->
      <my-input :value="roundTitle" table="当前轮次" placeholder="当前轮次" disabled @inputClick="selectRound()" />
      <my-input v-model="game.beginDate" table="开赛时间" placeholder="选择时间" disabled @inputClick="selectDate()" />
      <my-input v-if="match.ruleType === '淘汰赛' || game.ruleType === '淘汰赛' || game.stageName === '淘汰赛'"
        v-model="game.content" table="比赛性质" placeholder="请选择比赛性质" disabled @inputClick="goNature()" />
      <my-input v-if="liveScoreboardOpen == 1" v-model="game.fieldName" table="比赛场地" placeholder="请选择比赛场地" disabled @inputClick="showField = true" />
    </div>
    <div class="title">参赛队伍</div>
    <div class="form">
      <my-input v-model="game.homeName" table="主队" placeholder="请选择" disabled @inputClick="goTeam" />
      <my-input v-model="game.awayName" table="客队" placeholder="请选择" disabled @inputClick="goTeam" />
    </div>
    <div class="title">裁判信息</div>
    <div class="form" v-if="refereeFields.length > 0">
      <div v-for="(item, index) in refereeFields" :key="index">
        <my-input :value="getName(item.role)" :table="item.role" :placeholder="`请选择${item.role}`" disabled
          @inputClick="goReferee(item.role)" />
      </div>
    </div>
    <van-popup v-model="showType" round position="bottom">
      <van-picker :columns="columnsType" value-key="title" show-toolbar title="标题" @confirm="confirmType"
        @cancel="showType = false" />
    </van-popup>
    <van-popup v-model="showRound" round position="bottom">
      <van-picker :columns="columnsRound" value-key="title" show-toolbar title="标题" @confirm="confirmRound"
        @cancel="showRound = false" />
    </van-popup>
    <van-popup v-model="showDate" round position="bottom">
      <van-datetime-picker type="datetime" :value="defaultDate" :filter="filterDate" @confirm="confirmDate"
        @cancel="showDate = false" />
    </van-popup>
    <van-popup v-model="showStage" round position="bottom">
      <van-picker :columns="stagesList" value-key="stageName" show-toolbar @confirm="confirmStage"
        @cancel="showStage = false" />
    </van-popup>
    <van-popup v-model="showField" position="bottom" >
      <van-picker
        title="选择场地"
        value-key="name"
        show-toolbar
        :columns="fieldList"
        @confirm="onConfirm"
        @cancel="showField = false"
      />
    </van-popup>
    <div class="footer">
      <div @click="creeateGame">{{ id ? '保存信息' : '创建比赛' }}</div>
    </div>
  </div>
</template>

<script>
import { adminGetBMMatch, adminGetBMMatchStageTeamList, adminCreateBMMatchGame, adminGetBMMatchGame, adminUpdateBMMatchGame, getBMStageGamesByBMMatchId, adminGetBMUnionMatch } from '@/api/match'
import { adminGetUnionMatchFields } from '@/api/match-team-game'
import { DateUtil } from '@/utils'
import MyInput from '@/components/Input.vue'
import { Picker, Popup, DatetimePicker, Toast } from 'vant'
import Vue from 'vue'
Vue.use(Picker).use(Popup).use(DatetimePicker).use(Toast)
export default {
  components: {
    MyInput
  },
  data() {
    return {
      matchId: '',
      accountId: '',
      id: '',
      game: {},
      match: {},
      showType: false,
      columnsType: [],
      showRound: false,
      // columnsRound: [],
      showDate: false,
      filterDate(type, options) {
        if (type === 'minute') {
          return options.filter((option) => option % 5 === 0);
        }
        return options;
      },
      defaultDate: new Date(),
      teams: [],
      list: [
        { content: '冠/亚军赛', isChampionGame: 1 },
        { content: '3-4名排位赛', isChampionGame: 2 },
        { content: '5-6名排位赛', isChampionGame: 3 },
        { content: '7-8名排位赛', isChampionGame: 4 },
        { content: '交叉排位赛', isChampionGame: -1 },
        { content: '', isChampionGame: -2 },
      ],
      showStage: false,
      stagesList: [],
      refereeFields: [],
      fieldList: [],
      showField: false,
      liveScoreboardOpen: 0
    };
  },
  watch: {
    game: {
      handler() {
        this.$store.dispatch('changeDispatch', this.game);
      }
    },
  },
  mounted() {
    this.game = this.$store.state.game
    console.log(this.game);
    this.matchId = this.$route.query.matchId
    this.id = this.$route.query.id
    this.$set(this.game, 'matchId', this.$route.query.matchId)
    this.$set(this.game, 'id', this.$route.query.id)
    // debugger
    this.adminGetBMMatch()
  },
  computed: {
    roundTitle() {
      if (this.columnsRound.length === 0) return ''
      return this.columnsRound[this.game.round - 1]?.title
    },
    columnsRound() {
      if (!this.game.stageId) return []
      const stage = this.stagesList.find(s => s.id == this.game.stageId)
      console.log(stage, 'stage');
      if (!stage) return []
      const a = []
      for (let i = 1; i <= stage.roundCount; i++) {
        let label = `第${i}轮`
        if (stage.roundAliasList) {
          const obj = stage.roundAliasList.find(a => a.round === i) || null
          if (obj) {
            label += `(${obj.alias})`
          }
        }
        const item = {
          value: i,
          title: label
        }
        a.push(item)
      }
      console.log(a, 'aaa');
      return a
    },
  },
  methods: {
    onConfirm(item) { 
      this.$set(this.game, 'fieldId', item.id)
      this.$set(this.game, 'fieldName', item.name)
      this.showField = false
    },
    getBMStageGamesByBMMatchId() {
      getBMStageGamesByBMMatchId({ matchId: this.matchId }).then(res => {
        const data = res.data
        this.stagesList = data.stages
        if (data.stages.length === 1) {
          this.$set(this.game, 'ruleType', data.stages[0].ruleType)
          this.$set(this.game, 'stageName', data.stages[0].stageName)
          this.$set(this.game, 'stageId', data.stages[0].id)
        }
        if (this.id) {
          adminGetBMMatchGame({ id: this.id }).then(res1 => {
            if (res1) {
              const game = res1.data.game || {}
              this.$set(this.game, 'stageId', game.stageId)
              const stageName = this.stagesList.find(item => item.id == game.stageId).stageName
              this.$set(this.game, 'stageName', stageName)
              this.adminGetBMMatchStageTeamList()
            }
          })
        } else {
          this.adminGetBMMatchStageTeamList()
        }
      })
    },
    adminGetBMMatch() {
      adminGetBMMatch({ id: this.matchId }).then(res => {
        const match = res.data.match
        this.match = match
        this.unionMatchId = match.unionMatchId
        this.getBMStageGamesByBMMatchId()
        this.adminGetBMUnionMatch()
      })
    },
    adminGetUnionMatchFields() {
      adminGetUnionMatchFields({ unionMatchId: this.unionMatchId }).then(res => {
        const { data } = res
        this.fieldList = data.list
      })
    },
    adminGetBMMatchStageTeamList() {
      if (!this.game.stageId) return
      const params = {
        matchId: this.matchId,
        stageId: this.game.stageId
      }
      adminGetBMMatchStageTeamList(params).then(res => {
        const data = res.data
        this.teams = data.teams
        if (this.game.teamsId && this.game.teamsId.length > 0) {
          const teamsId = this.game.teamsId
          const home = this.teams.find(item => item.id == teamsId[0])
          if (home) {
            this.$set(this.game, 'homeTeamId', home.id)
            this.$set(this.game, 'homeName', home.name)
          }
          const away = this.teams.find(item => item.id == teamsId[1])
          if (away) {
            this.$set(this.game, 'awayTeamId', away.id)
            this.$set(this.game, 'awayName', away.name)
          }
        }
        if (this.id) {
          this.adminGetBMMatchGame()
        }
      })
    },
    adminGetBMMatchGame() {
      adminGetBMMatchGame({ id: this.id }).then(res => {
        const game = res.data.game
        const gameobj = {
          round: game.round,
          id: this.id,
          matchId: this.matchId
        }
        if (game.beginDate) {
          gameobj.beginDate = DateUtil.parseDateTime(game.beginDate, '{y}-{m}-{d} {h}:{i}')
          this.defaultDate = new Date(game.beginDate)
        }
        if (this.$store.state.game.beginDate) {
          gameobj.beginDate = this.$store.state.game.beginDate
          this.defaultDate = new Date(gameobj.beginDate)
        }
        if (this.$store.state.game.ruleType) {
          gameobj.ruleType = this.$store.state.game.ruleType
          // gameobj.isGroupGame = this.$store.state.game.isGroupGame

        } else {
          gameobj.ruleType = game.isGroupGame === 1 ? '循环赛' : '淘汰赛'
          // gameobj.isGroupGame = game.isGroupGame
        }
        if (this.$store.state.game.round) {
          gameobj.round = this.$store.state.game.round
        }
        if (this.$store.state.game.stageId) {
          gameobj.stageId = this.$store.state.game.stageId
          gameobj.stageName = this.$store.state.game.stageName
        }

        const teamsId = this.game.teamsId
        if (this.$store.state.game.teamsId && this.$store.state.game.teamsId.length > 0) {
          gameobj.teamsId = this.$store.state.game.teamsId
          const home = this.teams.find(item => item.id === teamsId[0])
          if (home) {
            gameobj.homeName = home.name
            gameobj.homeTeamId = home.id
          }
          const away = this.teams.find(item => item.id === teamsId[1])
          if (away) {
            gameobj.awayName = away.name
            gameobj.awayTeamId = away.id
          }
        } else {
          gameobj.teamsId = [game.homeTeamId, game.awayTeamId]
          gameobj.homeName = this.teams.find(item => item.id === game.homeTeamId)?.name || ''
          gameobj.awayName = this.teams.find(item => item.id === game.awayTeamId)?.name || ''
          gameobj.homeTeamId = game.homeTeamId
          gameobj.awayTeamId = game.awayTeamId
        }
        if (this.$store.state.game.isChampionGame) {
          gameobj.isChampionGame = this.$store.state.game.isChampionGame
          gameobj.content = this.$store.state.game.content
        } else {
          gameobj.isChampionGame = game.isChampionGame
          gameobj.content = game.roundDescription
        }
        if(this.$store.state.game.fieldId){
          gameobj.fieldId = this.$store.state.game.fieldId
          gameobj.fieldName = this.$store.state.game.fieldName
        } else {
          gameobj.fieldId = game.fieldId
          gameobj.fieldName = game.fieldName
        }
        if (this.$store.state.game.refereeFields) {
          gameobj.refereeFields = this.$store.state.game.refereeFields
        } else if (game.referee) {
          gameobj.refereeFields = game.referee
        } else {
          gameobj.refereeFields = this.refereeFields
        }
        this.game = gameobj
      })
    },
    stageType() {
      if (this.stagesList.length > 1) {
        this.showStage = true
      }
    },
    confirmStage(e) {
      console.log(e);
      this.$set(this.game, 'stageId', e.id)
      this.adminGetBMMatchStageTeamList()
      this.$set(this.game, 'ruleType', e.ruleType)
      this.$set(this.game, 'stageName', e.stageName)
      if (e.ruleType === '淘汰赛') {
        this.$set(this.game, 'isGroupGame', 0)
      }
      this.showStage = false
    },
    adminGetBMUnionMatch() {
      const params = {
        id: this.unionMatchId,
      }
      adminGetBMUnionMatch(params).then(res => {
        const data = res.data
        this.liveScoreboardOpen = data.match.liveScoreboardOpen
        if(data.match.liveScoreboardOpen == 1){
          this.adminGetUnionMatchFields()
        }
        const list = data.match.refereeFields.split('|').map(item => {
          return { refereeId: '', role: item, name: '' }
        })
        this.refereeFields = list
        if (this.$store.state.game.refereeFields) {
          this.$set(this.game, 'refereeFields', this.$store.state.game.refereeFields)
        } else if (!this.id) {
          this.$set(this.game, 'refereeFields', list)
        }
      })
    },
    getName(role) {
      let name = []
      if (!this.game.refereeFields) return
      this.game.refereeFields.map(item => {
        if (item.role === role) {
          name.push(item.name)
        }
        return
      })
      return name.join(',')
    },
    // 赛事类型
    selectType() {
      // if (this.match.ruleType === '小组赛+淘汰赛' && false) {
      //   this.showType = true
      // }
    },
    confirmType(e) {
      if (this.game.ruleType !== e.title) {
        this.$set(this.game, 'round', '')
        this.$set(this.game, 'roundTitle', '')
      }
      this.$set(this.game, 'isGroupGame', e.value)
      this.$set(this.game, 'ruleType', e.title)
      this.showType = false
    },
    // 当前论次
    selectRound() {
      this.showRound = true
    },
    confirmRound(e) {
      this.$set(this.game, 'roundTitle', e.title)
      this.$set(this.game, 'round', e.value)
      this.showRound = false
    },
    // 开赛时间
    selectDate() {
      this.showDate = true
    },
    confirmDate(e) {
      this.$set(this.game, 'beginDate', DateUtil.parseDateTime(e, '{y}-{m}-{d} {h}:{i}'))
      this.showDate = false
    },
    creeateGame() {
      const params = {
        name: '',
        ...this.game
      }
      params.roundDescription = this.game.content
      delete params.content
      const referee = params.refereeFields.filter(item => !!item.refereeId)
      params.referee = JSON.stringify(referee)
      delete params.refereeFields
      if (params.beginDate) {
        const parts = params.beginDate.split(" ");
        const datePart = parts[0];
        const timePart = parts[1];
        params.beginDate = `${datePart}T${timePart}:00+0800`;
      }
      if (this.id) {
        adminUpdateBMMatchGame(params).then(res => {
          if (res.data) {
            Toast('保存成功！')
            this.back()
            this.game = {}
          }
        })
      } else {
        adminCreateBMMatchGame(params).then(res => {
          if (res.data) {
            Toast('创建成功！')
            this.back()
            this.game = {}
          }
        })
      }
    },
    back() {
      if(this.$route.query.round && this.$route.query.stages && this.$route.query.roundId && this.$route.query.unionMatchId){
        this.$router.replace({ path: `/match-manage/match-list/${this.$route.query.unionMatchId}?matchId=${this.$route.query.matchId}&round=${this.$route.query.round}&stages=${this.$route.query.stages}&roundId=${this.$route.query.roundId}` })
      } else {
        this.$router.back()
      }
    },
    goTeam() {
      if (!this.game.stageId) {
        Toast('请先选择阶段')
        return
      }
      this.$router.push({ path: '/match-manage/team-list?matchId=' + this.matchId })
    },
    goReferee(i) {

      this.$router.push({ path: `/match-manage/referee-list?unionMatchId=${this.unionMatchId}&type=${i}` })
    },
    goNature() {
      this.$router.push({ path: '/match-manage/game-nature' })
    },
  },
};
</script>

<style scoped lang="scss">
.create-box {
  padding-bottom: 86px;

  .title {
    border-top: 14px solid #F9F9F9;
    padding: 20px 16px 18px 16px;
    font-size: 14px;
    color: #5B5B5B;
  }

  .form {
    padding: 0 16px;
  }
}

.footer {
  position: fixed;
  bottom: 0;
  background-color: #fff;
  width: 100%;
  padding: 16px 12px;

  div {
    height: 50px;
    background: #1565FC;
    border-radius: 25px;
    color: #fff;
    font-size: 16px;
    text-align: center;
    line-height: 50px;
    width: 351px;
  }
}
</style>
